import React from 'react';
import { Check } from 'lucide-react';
import { servicesList, companyInfo } from '../data/mockData';
import { useTheme } from '../context/ThemeContext';

const ServicesListSection = () => {
  const { isDark } = useTheme();

  return (
    <section className={`py-20 ${isDark ? 'bg-neutral-900' : 'bg-neutral-50'}`}>
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className={`text-2xl md:text-3xl font-bold mb-12 ${isDark ? 'text-white' : 'text-neutral-900'}`}>
          Our Suite of Services
        </h2>
        
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12 text-left">
          {servicesList.map((service, index) => (
            <li 
              key={index}
              className={`flex items-center gap-3 p-4 rounded-lg transition-colors ${isDark ? 'text-neutral-300 bg-neutral-800 hover:bg-neutral-750' : 'text-neutral-700 bg-white hover:bg-neutral-100 shadow-sm'}`}
            >
              <Check className="w-5 h-5 text-lime-500 flex-shrink-0" />
              <span>{service}</span>
            </li>
          ))}
        </ul>

        <div className="space-y-4">
          <p className={isDark ? 'text-neutral-400' : 'text-neutral-600'}>
            Call us today on{' '}
            <a 
              href={`tel:${companyInfo.phone}`} 
              className="text-lime-500 hover:text-lime-400 font-semibold transition-colors"
            >
              {companyInfo.phone}
            </a>{' '}
            for a free consultation on vehicle restoration in Murray Bridge.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServicesListSection;
